export default "__VITE_ASSET__CNGO7jNg__"